import {
  validatePresence,
  validateLength,
} from 'ember-changeset-validations/validators';

export default {
  name: validatePresence({ presence: true }),
  abbreviation: [validatePresence(true), validateLength({ min: 2, max: 2 })],
};
